import { CompositePhotoUploader } from "../PhotoUploader";

interface CompositePhotoSlotsProps {
  isAdultLayout: boolean;
  slotPhotos: {
    photo1?: string;
    photo2?: string;
    photo3?: string;
    photo4?: string;
  };
  onSelectSlot: (slot: "photo1" | "photo2" | "photo3" | "photo4") => void;
  onClearSlot: (slot: "photo1" | "photo2" | "photo3" | "photo4") => void;
}

export const CompositePhotoSlots = ({
  isAdultLayout,
  slotPhotos: { photo1, photo2, photo3, photo4 },
  onSelectSlot,
  onClearSlot,
}: CompositePhotoSlotsProps) => {
  return (
    <div className="w-full max-w-7xl p-[15px] gap-[15px] mx-auto aspect-[297/210] flex ">
      {isAdultLayout ? (
        <>
          <div className="flex-[2] h-[85%]">
            <CompositePhotoUploader
              className="w-full h-full"
              value={photo1}
              onClick={() => onSelectSlot("photo1")}
              onRemove={() => onClearSlot("photo1")}
            />
          </div>
          <div className="flex-[2] h-[85%]">
            <CompositePhotoUploader
              className="w-full h-full"
              value={photo2}
              onClick={() => onSelectSlot("photo2")}
              onRemove={() => onClearSlot("photo2")}
            />
          </div>

          <div className="flex-[1] h-[85%] gap-[15px] flex flex-col">
            <CompositePhotoUploader
              className="flex-1 w-full"
              value={photo3}
              onClick={() => onSelectSlot("photo3")}
              onRemove={() => onClearSlot("photo3")}
            />
            <CompositePhotoUploader
              className="flex-1 w-full"
              value={photo4}
              onClick={() => onSelectSlot("photo4")}
              onRemove={() => onClearSlot("photo4")}
            />
          </div>
        </>
      ) : (
        <>
          <div className="w-[35%] h-full">
            <CompositePhotoUploader
              className="w-full h-full"
              value={photo1}
              onClick={() => onSelectSlot("photo1")}
              onRemove={() => onClearSlot("photo1")}
            />
          </div>

          <div className="w-[65%] h-full flex flex-col">
            <div className="flex w-full h-[85%] gap-[15px]">
              <CompositePhotoUploader
                className="flex-1 h-full"
                value={photo2}
                onClick={() => onSelectSlot("photo2")}
                onRemove={() => onClearSlot("photo2")}
              />
              <CompositePhotoUploader
                className="flex-1 h-full"
                value={photo3}
                onClick={() => onSelectSlot("photo3")}
                onRemove={() => onClearSlot("photo3")}
              />
            </div>

            <div className="h-[15%] w-full flex flex-col justify-center px-2 opacity-30 pointer-events-none">
              <div className="h-4 w-1/2 bg-gray-200 mb-1" />
              <div className="h-3 w-1/4 bg-gray-100" />
            </div>
          </div>
        </>
      )}
    </div>
  );
};
